<template>
  <CardLayout @onHrTree="onHrTree">
    <div class="card-body">

        <div class="search-wrap">
          <el-button size="mini" type="primary text2" @click="editUser()">添加</el-button>
          <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-button size="mini" type="primary text2" @click="search">搜索</el-button>
        </div>

      <div class="table-wrap">
        <el-table v-loading="loading" class="chat-table" :data="tableData">
          <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
          <el-table-column prop="company_name" label="公司" align="center"></el-table-column>
          <el-table-column prop="company_address" label="地址" align="center"></el-table-column>
          <el-table-column prop="company_intro" label="公司介绍" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="company_share_intro" label="分享介绍" align="center" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="industry1" label="所属行业" align="center" ></el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="editUser(scope.row)">修改</el-button>
              <!--          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
      </div>

      <!-- 修改窗口 -->
      <el-dialog title="配置编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1200px">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属组织" prop="group_id">
                <!--            <SelectDepartment v-model="form.department_name" @change="form.department_id=$event.id;" />-->
                <SelectDepartmentCascader v-if="dialogVisible" v-model="form.department_name" @change="form.department_ids=$event.ancestor_id;" />
              </el-form-item>
              <el-form-item label="公司名称" prop="company_name">
                <el-input class="form-input" v-model="form.company_name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="公司地址" prop="company_address">
                <el-input class="form-input" v-model="form.company_address" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="所属行业" prop="industry1">
                <el-input class="form-input" v-model="form.industry1" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="公司介绍" prop="company_intro">
                <el-input class="form-input" v-model="form.company_intro"  type="textarea" :rows="5" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="分享介绍" prop="company_share_intro">
                <el-input class="form-input" v-model="form.company_share_intro"  type="textarea" :rows="5" autocomplete="off"></el-input>
              </el-form-item>
              <!--          <el-form-item label="卡片背景" prop="name">-->
              <!--            <UploadFileCard style="margin-top:5px;":list="form_imgs" :host-url="host_url" :upload-url="host_url+'/admin/CardBackground/uploadFile'" @success="UploadFileFJSuccess"/>-->
              <!--            <p style="color: #F56C6C;">请上传背景图尺寸为：680*360 px</p>-->
              <!--          </el-form-item>-->
              <el-form-item label="默认背景" prop="background_id">
                <el-select
                  v-model="form.background_id"
                  placeholder="选择背景">
                  <el-option
                    v-for="item in card_bg_list"
                    :key="item.id"
                    :label="item.id+'-'+item.name+'-'+(item.is_internal?'中奥':'其他')"
                    :value="(item.id*1)">
                    <div style="float: left">{{ item.id+'-'+item.name+'-'+(item.is_internal?'中奥':'其他') }}</div>
                    <div style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</div>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="可选背景" prop="background_ids">
                <el-select
                  v-model="form.background_ids"
                  placeholder="选择类型" clearable multiple>
                  <el-option
                    v-for="item in card_bg_list"
                    :key="item.id"
                    :label="item.name+'-'+(item.is_internal?'中奥':'其他')"
                    :value="(item.id+'')">
                    <div style="float: left">{{ item.name+'-'+(item.is_internal?'中奥':'其他') }}</div>
                    <div style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</div>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="主题样式" prop="card_style_id">
                <el-select
                  v-model="form.card_style_id"
                  placeholder="选择类型">
                  <el-option
                    v-for="item in card_style_list"
                    :key="item.id"
                    :label="item.name"
                    :value="(item.id*1)">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宣传视频" prop="company_name">
                <el-input class="form-input" v-model="form.company_video" placeholder="输入视频全链接" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="宣传图片" prop="company_name">
                <!--            <el-input class="form-input" v-model="form.company_image" placeholder="输入视频全链接" autocomplete="off"></el-input>-->
                <UploadFileSysc v-model="form.company_image" :host-url="host_url" :upload-url="host_url+'/admin/common/uploadFile?name=company_image'" />
              </el-form-item>
              <el-form-item label="公司LOGO" prop="company_logo">
                <UploadFileSysc v-model="form.company_logo" :host-url="host_url" :upload-url="`${host_url}/admin/common/uploadFile?name=company_logo`" />
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </CardLayout>

</template>

<script>

  import { Loading } from 'element-ui';
  import { User, UserGroup } from './common.js'
  import xhHelp from "./xhHelp";
  import UploadFileCard from "./components/UploadFileCard";
  import UploadFileSysc from "./components/UploadFileSysc";
  import CardLayout from "./components/CardLayout";
  import SelectDepartmentCascader from "./components/SelectDepartmentCascader";

export default {
  name: "CardConfig",
  components: {SelectDepartmentCascader, CardLayout, UploadFileSysc, UploadFileCard},
  data () {
    return {
      is_internal: '',
      group_id: '',
      keyword: '',
      loading: false,
      tableData: [],
      groupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      formLoading: false,
      form: {
        id:'',
        company_name:'',
        company_address:'',
        default_background:'',
        background_id:'0',
        background_ids:"",
        card_style_id:'0',
        company_intro:"",
        company_share_intro:"",
        industry1:"",
        company_video:"",
        company_image:"",
        department_name:"",
        department_ids:"",
        company_logo: ''
      },
      form_imgs:null,
      rules: {
      },
      articleTableData:[],
      articleKeyword:"",
      hostUrl:xhHelp.hostUrl,
      host_url:xhHelp.host_url,
      card_style_list:[],
      card_bg_list:[],
      bgId:''
    }
  },
  created() {

    UserGroup.getList(res => {
      if(res.code == 0) {
        this.groupList = res.data.data
      }
    })

    this.getList()
    this.getCardStyle('')
    this.getCardBg('')

  },
  methods: {
    getCardStyle(name=''){
      var that=this;
      xhHelp.get("CardStyle/getList",{keyword:name,page:1},ret=>{
        that.card_style_list=ret.data.data
      })
    },
    getCardBg(name=''){
      var that=this;
      xhHelp.get("CardBackground/getList",{keyword:name,page:1},ret=>{
        that.card_bg_list=ret.data.data
      })
    },
    getFormData(data) {
      return Object.assign({
        id:'',
        company_name:'',
        company_address:'',
        default_background:'',
        background_id:'0',
        background_ids:"",
        card_style_id:'0',
        company_video:"",
        company_image:"",
        company_logo:"",
        department_name:"",
        department_ids:""
      }, data)
    },
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      xhHelp.get("Config/getList",{
        keyword: this.keyword,
        department_id:this.department_id,
        page: this.page,
        page_size: this.pageSize
      },res => {
        if(res.code == 0) {
          if(res.code == 0) {
            this.total = res.data.total
            this.tableData = res.data.data
          }
        }
      })

    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editUser(item=null) {
      if(item){
        let data = {}
        for(let k in this.form) {
          data[k] = item[k]
          if(k==='background_ids'){
            item[k]?(typeof item[k]==="string"&&(data[k] = item[k].split(','))):(data[k]="")
          }

        }
        this.form = data
        this.form_imgs=[{url:this.hostUrl(data.default_background)}]
      }else {
        this.form=this.getFormData({})
        this.form_imgs=''
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          data.background_ids?(typeof data.background_ids ==="object"&&(data.background_ids = data.background_ids.join(','))):(data.background_ids="")
          xhHelp.post("Config/update",data,res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })

        } else {
          return false;
        }
      });
    },
    setFormItem(item){
      let data = Object.assign({}, item)
      data.background_ids?(typeof data.background_ids ==="object"&&(data.background_ids = data.background_ids.join(','))):(data.background_ids="")
      xhHelp.post("Config/update",data,res => {
        this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
        if(res.code == 0) {
          this.getList()
        }
      })
    },
    deleteUser(item) {

      this.$confirm('此操作将删除该会员['+item.phone+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        User.delete(item.id, res => {
          this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
          if(res.code == 0) {
            this.getList()
          }
        })
      })

    },
    UploadFileFJSuccess(file){
      if(file){
        this.form_imgs=[{url:this.hostUrl(file)}]
      }else {
        this.form_imgs=''
      }

      this.form.default_background=file;
    },
    onHrTree(e){
      const that=this;
      that.department_id=e.id;
      that.search();
    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/Config.vue